module.exports = __webpack_public_path__ + "img/otf2.371dbbc3.png";